import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import { TeuteufTooltip } from '@wt/game/providers/tooltips';
import { useUserProvider } from '@wt/game/providers/user/UserProvider';
import { isEmpty } from 'lodash';
import Link from 'next/link';
import { useEffect, useState } from 'react';

export const AccountAvatar = () => {
  const { loggedIn, user } = useUserProvider();

  return (
    <>
      {loggedIn ? <AccountPicture imageUrl={user.photoURL} /> : <LoginButton />}
    </>
  );
};

const LoginButton = () => {
  const { showLoginTooltip, setShowLoginToolip } = useUserProvider();

  return (
    <TeuteufTooltip
      id="login"
      onceOnly={false}
      active={showLoginTooltip}
      localStorageKey="hide-login-tooltip"
      text="Log in to make sure you save your stats!"
      onClose={() => {
        setShowLoginToolip(false);
      }}
    >
      <Link
        onClick={() => {
          localStorage.setItem('post-login-location', window.location.pathname);
        }}
        href={'/login'}
      >
        <AccountBoxOutlinedIcon className="header-icon" />
      </Link>
    </TeuteufTooltip>
  );
};

const AccountPicture = ({ imageUrl }: { imageUrl: string }) => {
  const [imageError, setImageError] = useState(false);

  const handleError = () => {
    setImageError(true);
  };

  const imgSrc =
    !imageError && !isEmpty(imageUrl)
      ? imageUrl
      : '/assets/fallback-avatar.png';

  return (
    <Link href={'/account'} className="flex items-center justify-center">
      <div
        data-image-src={imgSrc}
        className="relative size-[24px] overflow-hidden rounded-full md:size-[35px] flex items-center justify-center"
      >
        <img
          src={imgSrc}
          referrerPolicy="no-referrer"
          onError={handleError}
          aria-label="Account"
          className="absolute inset-0 size-full object-cover object-center"
        />
      </div>
    </Link>
  );
};
